import React, { Reducer, useEffect, useReducer } from 'react'
import PhoneInput from 'react-phone-input-2'
import { Autocomplete } from '@material-ui/lab'
import { Country, State, useCheckQrExpiryQuery, useCountryListingQuery, useGetEInvoiceBuyerInfoQuery, useHotelDetailsQuery, useStateListingQuery, useUpdateEInvoiceDebtorInfoMutation } from 'generated/graphql'
import Logo from 'assets/images/HotelX-Logo.png'
import Background from 'assets/images/HR-Background.jpg'
import theme from '@ifca-root/react-component/src/assets/theme';
import { TextField, Card, CardContent, useMediaQuery, Button } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { IAction } from 'containers/helper/models';
import queryString from 'query-string'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'

interface Props {
  HotelID?: string
  FolioID?: string
  BuyerDetail?: {
    BuyerName?: string,
    BuyerEmail?: string,
    BuyerContactNo?: string,
    BuyerAddress?: string,
    BuyerCity?: string,
    BuyerState?: string,
    BuyerCountry?: string,
    BuyerPostcode?: string,
    BuyerIdentityNo?: string,
    BuyerIdentityType?: string,
    BuyerTinNo?: string,
    BuyerSSTNo?: string
  }
}

type IdentityTypeOption = {
  id: string
  description: string
}

interface StateType {
  ID: string;
  name: string;
  countryID: string;
}

export const EInvoiceBuyerDetailForm = () => {
  const location = useLocation()
  let history = useHistory()
  const localState: any = location.state
  const debtorInfo = queryString.parse(location.search)

  const HotelAddress = JSON.parse(localStorage.getItem('Hotel'))?.HotelAddress
  const DefaultCountry = HotelAddress?.country
  const DefaultState = HotelAddress?.state

  const [UpdateEInvoiceDebtor] = useUpdateEInvoiceDebtorInfoMutation()

  const {
    loading: getEInvoiceBuyerInfoLoading,
    data: { getEInvoiceBuyerInfo } = { getEInvoiceBuyerInfo: null },
  } = useGetEInvoiceBuyerInfoQuery({
    variables: {
      HotelID: debtorInfo.HotelID ? debtorInfo.HotelID as string : JSON.parse(localStorage.getItem('Hotel'))?.ID,
      DebtorID: debtorInfo.DebtorID ? debtorInfo.DebtorID as string : null,
      RegistrationID: debtorInfo.RegistrationID ? debtorInfo.RegistrationID as string : null,
      FolioID: debtorInfo.FolioID ? debtorInfo.FolioID as string : null,
      Module: debtorInfo.Module ? (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '') : null
    },
    fetchPolicy: 'no-cache'
  })

  const {
    data: { CountryListing } = { CountryListing: [] },
    loading: CountryListingLoading,
  } = useCountryListingQuery({
    fetchPolicy: 'no-cache',
  })

  const {
    data: { StateListing } = { StateListing: [] },
    loading: StateListingLoading,
  } = useStateListingQuery({
    fetchPolicy: 'no-cache',
  })

  const filteredStates = StateListing.filter(x => x.countryID === CountryListing.find(x=> x.name === 'Malaysia')?.ID)

  const {
    loading: CheckQRExpiryLoading
  } = useCheckQrExpiryQuery({
    variables: {
      HotelID: debtorInfo.HotelID as string || JSON.parse(localStorage.getItem('Hotel'))?.ID,
      FloatingID: debtorInfo.FolioID as string,
      Module: debtorInfo.Module ? (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '') : null,
      DocType: (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '') === 'CityAccount' 
        ? 'INV'
        : null
    },
    onCompleted: ({ CheckQRExpiry }) => {
      if (CheckQRExpiry === true) {
        setTimeout(() => { 
          history.push(`/buyer-detail-expired?HotelID=${debtorInfo.HotelID as string}&FloatingID=${debtorInfo.FolioID as string}`)
        }, 1000)
      }
    },
    fetchPolicy: 'no-cache'
  })

  const initialState: Props = {
    HotelID: localState?.folioInfo?.HotelID || JSON.parse(localStorage.getItem('Hotel'))?.ID,
    FolioID: localState?.folioInfo?.ID,
    BuyerDetail: {
      BuyerName: getEInvoiceBuyerInfo?.einvoice_buyer_name || '',
      BuyerEmail: getEInvoiceBuyerInfo?.einvoice_buyer_email || '',
      BuyerContactNo: getEInvoiceBuyerInfo?.einvoice_buyer_contact_no || '',
      BuyerAddress: getEInvoiceBuyerInfo?.einvoice_buyer_address || '',
      BuyerCity: getEInvoiceBuyerInfo?.einvoice_buyer_city || '',
      BuyerState: getEInvoiceBuyerInfo?.einvoice_buyer_state || DefaultState || '',
      BuyerCountry: getEInvoiceBuyerInfo?.einvoice_buyer_country || DefaultCountry || '',
      BuyerPostcode: getEInvoiceBuyerInfo?.einvoice_buyer_post_code || '',
      BuyerIdentityNo: getEInvoiceBuyerInfo?.einvoice_buyer_regno || '',
      BuyerIdentityType: getEInvoiceBuyerInfo?.einvoice_buyer_identity_type || '',
      BuyerTinNo: getEInvoiceBuyerInfo?.einvoice_buyer_tax_regno || '',
      BuyerSSTNo: getEInvoiceBuyerInfo?.einvoice_buyer_tin || ''
    }
  }

  const reducer: Reducer<Props, IAction> = (state, action) => {
    switch (action.type) {
      case 'reset':
        return initialState
      default:
        return { ...state, [action.type]: action.payload }
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	})

  let CountryEnum: any = Object.values(Country).map(i => { return i.replace(/_/g, ' ') })
  let StateEnum: any = Object.values(State).map(i => { return i.replace(/_/g, ' ') })

  const { data: { HotelDetails } = { HotelDetails: null } } = useHotelDetailsQuery({
    variables: {
      HotelID: JSON.parse(localStorage.getItem('Hotel'))?.ID,
    },
    fetchPolicy: 'no-cache',
  })

  const eInvoiceIdentityTypeOptions = [
    { id: 'NRIC', description: 'Identity Card (NRIC)' },
    { id: 'PASSPORT', description: 'Passport' },
    { id: 'BRN', description: 'Business Registration Number (BRN)' },
    { id: 'ARMY', description: 'Military Card' }
  ]
  
  const hotelLogo = HotelDetails?.LogoImage?.ImageURL

  useEffect(() => {
    if (getEInvoiceBuyerInfo) {
      dispatch({
        type: 'BuyerDetail',
        payload: {
          BuyerName: getEInvoiceBuyerInfo?.einvoice_buyer_name,
          BuyerEmail: getEInvoiceBuyerInfo?.einvoice_buyer_email,
          BuyerContactNo: getEInvoiceBuyerInfo?.einvoice_buyer_contact_no,
          BuyerAddress: getEInvoiceBuyerInfo?.einvoice_buyer_address,
          BuyerCity: getEInvoiceBuyerInfo?.einvoice_buyer_city,
          BuyerState: getEInvoiceBuyerInfo?.einvoice_buyer_state 
            ? getEInvoiceBuyerInfo?.einvoice_buyer_state 
            : DefaultState,
          BuyerCountry: getEInvoiceBuyerInfo?.einvoice_buyer_country 
            ? getEInvoiceBuyerInfo?.einvoice_buyer_country
            : DefaultCountry,
          BuyerPostcode: getEInvoiceBuyerInfo?.einvoice_buyer_post_code,
          BuyerIdentityNo: getEInvoiceBuyerInfo?.einvoice_buyer_regno,
          BuyerIdentityType: getEInvoiceBuyerInfo?.einvoice_buyer_identity_type,
          BuyerTinNo: getEInvoiceBuyerInfo?.einvoice_buyer_tin,
          BuyerSSTNo: getEInvoiceBuyerInfo?.einvoice_buyer_tax_regno
        }
      })
    }
  }, [getEInvoiceBuyerInfo])

  const handleSubmit = () => {
    if (debtorInfo.DebtorID || debtorInfo.ContactID || debtorInfo.FolioID || debtorInfo.RegistrationID) {
      UpdateEInvoiceDebtor({
        variables: {
          HotelID: debtorInfo.HotelID as string || JSON.parse(localStorage.getItem('Hotel'))?.ID,
          DebtorID: debtorInfo.DebtorID as string,
          FolioID: debtorInfo.FolioID as string,
          ContactID: debtorInfo.ContactID as string,
          BuyerInfoInput: {
            BuyerName: state.BuyerDetail?.BuyerName,
            BuyerEmail: state.BuyerDetail?.BuyerEmail,
            BuyerContactNo: state.BuyerDetail?.BuyerContactNo,
            BuyerAddress: {
              address: state.BuyerDetail?.BuyerAddress,
              state: state.BuyerDetail?.BuyerState,
              city: state.BuyerDetail?.BuyerCity,
              country: state.BuyerDetail?.BuyerCountry,
              postCode: state.BuyerDetail?.BuyerPostcode
            },
            BuyerSSTNo: state.BuyerDetail?.BuyerSSTNo,
            BuyerIdentityNo: state.BuyerDetail?.BuyerIdentityNo,
            BuyerIdentityType: state.BuyerDetail?.BuyerIdentityType,
            BuyerTinNo: state.BuyerDetail?.BuyerTinNo
          },
          RegistrationID: debtorInfo.RegistrationID as string,
          Module: (debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, ''),
        }
      }).then(i => {
        if (i.data.updateEInvoiceDebtorInfo) {
          setTimeout(() => { 
            history.push(`/buyer-detail-completed?HotelID=${debtorInfo.HotelID as string}&FolioID=${debtorInfo.FolioID as string}&Module=${(debtorInfo.Module as string).trim().replace(/[^a-zA-Z]/g, '')}`)
          }, 1000)
        }
      })
    }
  }

  const isDisabled = () => {
    const b = state.BuyerDetail
    if (!b) return true

    const requiredFields = [
      b.BuyerName,
      // b.BuyerEmail,
      b.BuyerContactNo,
      b.BuyerAddress,
      b.BuyerCity,
      b.BuyerState,
      b.BuyerCountry,
      b.BuyerPostcode,
      b.BuyerSSTNo,
      b.BuyerIdentityNo,
      b.BuyerIdentityType,
      b.BuyerTinNo,
    ]

    return requiredFields.some(
      v => v === null || v === undefined || v === ''
    )
  }


  return (
    <>
      {getEInvoiceBuyerInfoLoading && <Loading/>}
      {CheckQRExpiryLoading && <Loading />}
      <div
        className='einv-layout'
        style={{
          background: 'url("' + Background + '") no-repeat center center fixed'
        }}
      >
        <div className='form-box'>
            {/* <span 
              style={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',      
                height: '100%',
              }}
            >
              <img 
                src={hotelLogo ? hotelLogo : Logo}
                style={{ 
                  width: '100px',
                  height: 'auto',
                }}
              />
            </span> */}
            <span
              style={{
                fontFamily: 'Poppins, sans-serif',
                color: "#FFFFFF",
                fontWeight: 700,
                fontSize: '15px',
                display: 'flex', 
                justifyContent: 'center',
                padding: '5px 0',
                marginTop: '2px',
                marginBottom: '4px'
              }}
            >
              e-Invoice Buyer Details
            </span>

            <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '2px'}}>
              <Card
                style={{
                  margin: '5px 0',
                  borderRadius: '5px', 
                  width: '95%'
                }}
              >
                <CardContent>
                  <TextField
                    label="Name"
                    name="Name"
                    required={true}
                    value={state.BuyerDetail?.BuyerName}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerName: e.target.value
                        } 
                      })
                    }}
                    margin='dense'
                    fullWidth
                  />
                  <TextField
                    label="Email"
                    name="Email"
                    // required={true}
                    value={state.BuyerDetail?.BuyerEmail}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerEmail: e.target.value
                        } 
                      })
                    }}
                    margin='dense'
                    fullWidth
                    type="email"
                  />
                  <PhoneInput
                    containerClass="contact-input-new"
                    inputProps={{
                      name: 'ContactNo',
                      required: true,
                      margin: 'dense'
                    }}
                    specialLabel="Contact No."
                    country={'my'}
                    value={state.BuyerDetail?.BuyerContactNo || ''}
                    onChange={e => {
                      dispatch({
                        type: 'BuyerDetail',
                        payload: {
                          ...state.BuyerDetail,
                          BuyerContactNo: e
                        }
                      })
                    }}
                  />
                  <TextField
                    label="Address"
                    name="Address"
                    value={state.BuyerDetail?.BuyerAddress}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerAddress: e.target.value
                        } 
                      })
                    }}
                    fullWidth
                    margin='dense'
                    required={true}
                  />

                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                    <Autocomplete
                      options={CountryEnum}
                      style={{ width: '50%' }}
                      className='left'
                      getOptionLabel={option => option || ''}
                      value={state.BuyerDetail?.BuyerCountry || ''}
                      onChange={(_, value) => {
                        dispatch({
                          type: 'BuyerDetail',
                          payload: {
                            ...state.BuyerDetail,
                            BuyerCountry: value,
                            BuyerState: ''
                          }
                        })
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          required
                          label="Country"
                          margin="dense"
                          style={{ width: '100%' }}
                        />
                      )}
                    />
                    {state.BuyerDetail?.BuyerCountry?.toLowerCase() === 'malaysia' ? (
                      <Autocomplete<StateType, false, false, false>
                        options={filteredStates}
                        style={{ width: '50%' }}
                        className='right'
                        getOptionLabel={option => option?.name || ''}
                        value={StateListing.find(x => x.name === state.BuyerDetail?.BuyerState) || null}
                        onChange={(_, value) => {
                          dispatch({
                            type: 'BuyerDetail',
                            payload: {
                              ...state.BuyerDetail,
                              BuyerState: value?.name
                            }
                          })
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            required
                            label="State"
                            margin="dense"
                            style={{ width: '100%' }}
                          />  
                        )}
                      />
                    ) : (
                      <TextField
                        label="State"
                        fullWidth
                        margin="dense"
                        required={true}
                        style={{ width: '50%' }}
                        className="right"
                        InputLabelProps= {{
                          shrink: true,
                        }}
                        name="State"
                        value={state.BuyerDetail?.BuyerState || ''}
                        onChange={e => {
                          dispatch({
                            type: 'BuyerDetail',
                            payload: {
                              ...state.BuyerDetail,
                              BuyerState: e.target.value
                            }
                          })
                        }}
                      />
                    )}
                  </div>

                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                    <TextField
                      label="City"
                      name="City"
                      value={state.BuyerDetail?.BuyerCity}
                      onChange={e => {
                        dispatch({ 
                          type: 'BuyerDetail', 
                          payload: {
                            ...state.BuyerDetail,
                            BuyerCity: e.target.value
                          } 
                        })
                      }}
                      fullWidth
                      margin='dense'
                      required={true}
                    />
                    <TextField
                      label="Postcode"
                      name="Postcode"
                      value={state.BuyerDetail?.BuyerPostcode}
                      onChange={e => {
                        dispatch({ 
                          type: 'BuyerDetail', 
                          payload: {
                            ...state.BuyerDetail,
                            BuyerPostcode: e.target.value
                          } 
                        })
                      }}
                      fullWidth
                      margin='dense'
                      required={true}
                    />
                  </div>

                  <Autocomplete<IdentityTypeOption, false, false, false>
                    options={eInvoiceIdentityTypeOptions}
                    fullWidth
                    getOptionLabel={option => option?.description || ''}
                    value={eInvoiceIdentityTypeOptions.find((opt) => opt?.id === state?.BuyerDetail?.BuyerIdentityType) || null}
                    onChange={(_, value) => {
                      dispatch({
                        type: 'BuyerDetail',
                        payload: {
                          ...state.BuyerDetail,
                          BuyerIdentityType: value?.id
                        }
                      })
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        required
                        label="Identity Type"
                        margin="dense"
                        style={{ width: '100%' }}
                      />  
                    )}
                  />
                  <TextField
                    label="Identity Number"
                    name="IdentityNo"
                    value={state.BuyerDetail?.BuyerIdentityNo}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerIdentityNo: e.target.value
                        } 
                      })
                    }}
                    fullWidth
                    margin='dense'
                    required={true}
                  />
                  <TextField
                    label="Tax Identification Number"
                    name="TINNo"
                    value={state.BuyerDetail?.BuyerTinNo}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerTinNo: e.target.value
                        } 
                      })
                    }}
                    fullWidth
                    margin='dense'
                    required={true}
                  />
                  <TextField
                    label="SST Registration Number"
                    name="SSTNo"
                    value={state.BuyerDetail?.BuyerSSTNo}
                    onChange={e => {
                      dispatch({ 
                        type: 'BuyerDetail', 
                        payload: {
                          ...state.BuyerDetail,
                          BuyerSSTNo: e.target.value
                        } 
                      })
                    }}
                    fullWidth
                    margin='dense'
                    required={true}
                  />
                </CardContent>
              </Card>
            </div>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="submit-detail-btn"
              onClick={handleSubmit}
              disabled={isDisabled()}
            >
              Save
            </Button> 
        </div>     
      </div>
    </>
  )
} 